import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Running Builds',
  content: `
Builds in Pliable compile your configured data model, cleaning rules, and mappings into executable workflows. Use this to validate your setup, test transformations, or deploy changes to production.

# Builds

1. **Initiate a Build**

   Navigate to **Build** in the top right corner of any source node screen.

   Select the dependencies and settings:
   - **Include upstream nodes**: Builds all entities and data sources upstream that have changed.
   - **Include downstream nodes**: Builds all entities downstream after building current node.
   - **Force**: Builds all selected nodes regardless of if they have changed or received new data since the last build.
   - **Check for new data**: Checks your data sources for new data before building. Note that this happens automatically for scheduled builds in production.

2. **Monitor Progress**

   Track build status in real time via the **Activity Log**.

   View details like:
   - Rows processed per entity.
   - Cleaning rule warnings (e.g., 12 invalid dates standardized).
   - Mapping errors (e.g., Unmapped column "discount_rate").

3. **Resolve Errors**

   Failed builds highlight errors with actionable fixes (e.g., Missing entity for column "sku").

   Click **Retry Build** after resolving issues.

4. **Review Outputs**

   Successful builds generate:
   - A summary report.
   - Previewable data tables in the Semantic Layer.

# Use Cases

- **Testing**: Run a Develop build to validate new metrics before deployment.
- **Debugging**: Identify mapping errors in large datasets.
- **Deployment**: Push a Production build to update live reports.

> 📎  You can cancel a build while it's running by clicking on **Cancel Build**.
`,
};

export default doc;
